import { z } from 'zod';
import { DevDocumentKind, DevDocumentStatus } from '@/features/stacktrace/dev-documents/-query/type';
import { ProductDevDocumentTableColumns } from './-table/type';

/**
 * プロダクト詳細 > 開発ドキュメントタブ の URL search スキーマ。
 *
 * - freeText:       テキスト検索（BE は title / code / summary / triggerDescription が対象）
 * - kind:           種別の単一選択フィルタ（未指定 = 全種別）
 * - status:         ステータスの単一選択フィルタ（未指定 = 全ステータス）
 * - pageIndex:      0-origin ページ番号
 * - pageSize:       1 ページあたりの件数
 * - sortColumn:     ソート対象カラム（既定: 更新日）
 * - orderDirection: ソート方向（既定: 降順）
 *
 * `productId` は URL パスの `$id` が正なので search には持たない。
 * 台帳の一覧画面と違いステータスはタブではなくチップなので、既定値を置かず
 * 「絞り込みなし」から始める。
 */
export const ProductDevDocumentTableFilterSchema = z.object({
  freeText: z.string().optional(),
  kind: z.nativeEnum(DevDocumentKind).optional(),
  status: z.nativeEnum(DevDocumentStatus).optional(),
  pageIndex: z.coerce.number().min(0).default(0),
  pageSize: z.coerce.number().min(1).max(1000).default(100),
  sortColumn: z.nativeEnum(ProductDevDocumentTableColumns).default(ProductDevDocumentTableColumns.UPDATED_AT),
  orderDirection: z.enum(['asc', 'desc']).default('desc')
});